import React from "react";
import styled from "styled-components";

interface AnimatedCircleButtonProps {
  icon: string;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
}

const AnimatedCircleButton: React.FC<AnimatedCircleButtonProps> = ({
  icon,
  label,
  onClick,
  disabled,
  title,
}) => {
  return (
    <StyledButton type="button" onClick={onClick} disabled={disabled} title={title}>
      <span className="circle" aria-hidden="true">
        <i className={icon} />
      </span>
      <span className="button-text">{label}</span>
    </StyledButton>
  );
};

const StyledButton = styled.button`
  position: relative;
  display: block;
  width: 100%;
  height: 56px;
  border: 1px solid rgba(130, 78, 235, 0.3);
  border-radius: 28px;
  outline: none;
  cursor: pointer;
  background: rgba(130, 78, 235, 0.08);

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .circle {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto 0;
    width: 54px;
    height: 55px;
    border-radius: 27px;
    background: linear-gradient(135deg, #824eeb, #a97bf0);
    transition: width 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  .circle i {
    position: absolute;
    top: 50%;
    left: 18px;
    transform: translateY(-50%);
    font-size: 17px;
    color: #fff;
  }

  .button-text {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 27px;
    color: #824eeb;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 0.02em;
    transition: color 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  &:not(:disabled):hover .circle {
    width: 100%;
    box-shadow: 0 10px 30px -8px rgba(130, 78, 235, 0.6);
  }

  &:not(:disabled):hover .button-text {
    color: #fff;
  }
`;

export default AnimatedCircleButton;
